/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import userActions from '@store/actions/authentication';
import { MESSAGES } from '@translations/labels';
import SvgIconBot from '@svg/IconBot';
import logo from '@svg/logoAXABots.svg';
import { ROUTES } from '@constants';

import registerStyles from './registerPageStyles';

const labels = { ...MESSAGES.register, ...MESSAGES.commons };

const RegisterPage = () => {
  const [user, setUser] = useState({
    name: '',
    email: '',
    password: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();

  // reset user status
  useEffect(() => {
    dispatch(userActions.logout());
  }, []);

  const handleChange = e => {
    setSubmitted(false);
    const { name, value } = e.target;
    setUser(userUpdated => ({ ...userUpdated, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    setSubmitted(true);
    if (user.name && user.email && user.password) {
      dispatch(userActions.register(user));
    }
  };

  return (
    <div className="register-content">
      <div className="robot">
        <SvgIconBot />
      </div>
      <div className="register-container z-50">
        <h1>
          <img src={logo} alt={labels.nlpImgAlt} />
          {labels.title}
        </h1>
        <div className="wrapper">
          <h2 className="uppercase">{labels.register}</h2>
          <form name="register" onSubmit={handleSubmit}>
            <div className="register-form-container vertical-centered-flex">
              <div className="label-input-field">
                <label htmlFor="username">
                  {labels.userInput}
                  <input id="username" type="text" name="name" value={user.name} onChange={handleChange} />
                  {submitted && !user.name && (
                    <div className="invalid-feedback">{`${labels.userInput} ${labels.fieldRequired}`}</div>
                  )}
                </label>
              </div>
              <div className="label-input-field">
                <label htmlFor="email">
                  {labels.emailInput}
                  <input
                    id="email"
                    type="text"
                    name="email"
                    value={user.email}
                    onChange={handleChange}
                    className={submitted && !user.email ? ' is-invalid' : ''}
                    autoComplete="username"
                  />
                  {submitted && !user.email && (
                    <div className="invalid-feedback">{`${labels.emailInput} ${labels.fieldRequired}`}</div>
                  )}
                </label>
              </div>
              <div className="label-input-field">
                <label htmlFor="password">
                  {labels.passwordInput}
                  <input
                    id="password"
                    type="password"
                    name="password"
                    value={user.password}
                    onChange={handleChange}
                    className={submitted && !user.password ? ' is-invalid' : ''}
                    autoComplete="new-password"
                  />
                  {submitted && !user.password && (
                    <div className="invalid-feedback">{`${labels.passwordInput} ${labels.fieldRequired}`}</div>
                  )}
                </label>
              </div>
              <button className="btn-primary" type="submit">
                {labels.submit}
              </button>
              <Link to={ROUTES.login.path} className="link-secondary block">
                {labels.cancel}
              </Link>
            </div>
          </form>
        </div>
      </div>
      <style jsx>{registerStyles}</style>
    </div>
  );
};

export { RegisterPage };
